import * as types from "./mutation-types";
import { propertiesService } from "@/services";
import { messageHelper } from "@/helpers/message_helper";

export const fetchPropertyList = async ({ commit }, queryParams) => {
  commit(types.SET_IS_LOADING, true);

  try {
    const response = await propertiesService.list(queryParams);
    commit(types.SET_PROPERTY_LIST, response.data.data);
  } catch (error) {
    messageHelper.displayError("Ocorreu um erro inesperado.");
  } finally {
    commit(types.SET_IS_LOADING, false);
  }
};

// eslint-disable-next-line no-unused-vars
export const getPropertyById = async ({ commit }, propertyId) => {
  let property = {};

  try {
    const response = await propertiesService.getById(propertyId);
    property = response.data.data;
  } catch (error) {
    messageHelper.displayError("Ocorreu um erro inesperado.");
  }

  return property;
};

// eslint-disable-next-line no-unused-vars
export const createProperty = async ({ commit }, payload) => {
  let property = null;

  try {
    const response = await propertiesService.create(payload);
    property = response.data.data;
  } catch (error) {
    messageHelper.displayError("Ocorreu um erro inesperado.");
  }

  return property;
};

// eslint-disable-next-line no-unused-vars
export const updateProperty = async ({ commit }, payload) => {
  let property = null;

  try {
    const response = await propertiesService.update(payload);
    property = response.data.data;
  } catch (error) {
    messageHelper.displayError("Ocorreu um erro inesperado.");
  }

  return property;
};

export const updatePropertySearch = async ({ commit }, payload) => {
  commit(types.SET_SEARCH, payload);
};
